import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../../models/api.model';
import { GroupLink } from '../models/group-links.model';
import { WhitelistData } from './private-selling.service';

@Injectable({
  providedIn: 'root',
})
export class GroupLinkService {
  private http = inject(HttpClient);

  private apiRoot = '/bo/group-links';

  public getAll$(page?: number): Observable<ApiResponse<GroupLink[]>> {
    let params = new HttpParams()
      .set('orderBy', 'created_at')
      .set('orderType', 'desc');

    if (page) {
      params = params.set('page', page.toString());
    }

    return this.http.get<ApiResponse<GroupLink[]>>(
      environment.apiURl + `${this.apiRoot}`,
      { params }
    );
  }

  public get$(id: number): Observable<ApiResponse<GroupLink>> {
    return this.http.get<ApiResponse<GroupLink>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public create$(
    body: Partial<Omit<GroupLink, 'events' | 'privateSellingWhitelists'>> & {
      events: number[];
      privateSellingWhitelists: WhitelistData[];
    }
  ): Observable<ApiResponse<GroupLink>> {
    return this.http.post<ApiResponse<GroupLink>>(
      environment.apiURl + `${this.apiRoot}`,
      body
    );
  }

  public delete$(id: number): Observable<ApiResponse<Pick<GroupLink, 'id'>>> {
    return this.http.delete<ApiResponse<Pick<GroupLink, 'id'>>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public update$(
    id: number,
    body: Partial<Omit<GroupLink, 'events' | 'privateSellingWhitelists'>> & {
      events?: number[];
      privateSellingWhitelists?: WhitelistData[];
    }
  ): Observable<ApiResponse<GroupLink>> {
    return this.http.patch<ApiResponse<GroupLink>>(
      environment.apiURl + `${this.apiRoot}/${id}`,
      body
    );
  }
}
